import {
    deleteRoutePaymentLoading,
    deleteRoutePaymentRequest,
    deleteRoutePaymentSuccess,
    deleteRoutePaymentReject,
    deleteRoutePaymentReset,
} from "../../actions/route/deletePayment";

export const deleteRoutePayment = (formData) => async (dispatch, getState) => {
    dispatch(deleteRoutePaymentLoading());
    try {
        const { data } = await deleteRoutePaymentRequest(formData, getState);
        dispatch(deleteRoutePaymentSuccess(data))
    } catch (error) {
        dispatch(deleteRoutePaymentReject(error))
    } finally {
        setTimeout(() => { dispatch(deleteRoutePaymentReset()) }, 3000);
    }
    return Promise.resolve();
};